import { calendarListMobileViewComponent } from './calendar-list-mobile-view.component';

export const mobileCalendarList = angular
.module("common.components.calendarListMobileView", [])
.run(($templateCache) => {
    'ngInject';
    $templateCache.put('eventMobileViewTemplate.html',`
        <h2 ng-style=\"dayDetail.style\" class="no-capitalized">{{dayDetail.name}}</h2>
        <p ng-style=\"dayDetail.style\" ng-if=\"dayDetail.isAllDay\">all day</p>
        <p ng-style=\"dayDetail.style\" ng-if=\"!dayDetail.isAllDay && dayDetail.type === 'event'\"> 
        {{dayDetail.startDate | date: 'shortTime'}} - {{dayDetail.endDate | date: 'shortTime'}}</p>
    `);
})
.component("calendarListMobileView", calendarListMobileViewComponent)
.name;


// WEBPACK FOOTER //
// ./src/app/common/components/calendar-list-mobile-view/calendar-list-mobile-view.module.js